import "./App.scss";
import Chatbox from "./Chatbox";

function App() {
  return (
    <div className="App">
      <style>{`:root {
        --bg: #efedff;
        --primary: #0982FC;
        --blue: #0175FF;
        --grey: #f6f4ff;
        --grey-d-1: #eee;
        --grey-d-2: #ddd;
        --grey-d-3: #e2e2e2;
        --white: #fff;
        --dark: #222;
      }`}</style>
      <Chatbox />
    </div>
  );
}

export default App;
